var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasChartData)?_c('pie-chart',{attrs:{"chart-data":_vm.chartData,"tooltips-callback-cfg":_vm.tooltipsCallbackCfg,"width":300,"height":300}}):_c('no-data-found',{staticClass:"mx-auto"})}
var staticRenderFns = []

export { render, staticRenderFns }